import { FeedItem, SurveyFeedItem } from '../models/data';
import BaseService from './BaseService';

export interface FeedResponse {
  feedItems: FeedItem[];
  surveyFeedItems: SurveyFeedItem[];
}

export class FeedItemService extends BaseService {
  async getFeedItems() {
    return (await this.getJson<FeedResponse>('/feed')).data;
  }

  async completeSurvey(surveyId: string) {
    return (await this.postJson<void>(`/feed/surveys/${surveyId}/complete`, {})).data;
  }
}

export default new FeedItemService();
